exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site:not(.icon) {\n  font-family: \"Monda\", sans-serif; }\n  .site:not(.icon) .page {\n    padding: 1rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/layouts/site/site.scss
// module id = 177
// module chunks = 16